import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ROUTES } from './teacher.routes';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { OwlDateTimeModule, OwlNativeDateTimeModule, OWL_DATE_TIME_FORMATS} from '@danielmoncada/angular-datetime-picker';
import { SharedPostLoginModule } from '../shared-postlogin/shared-postlogin.module';
import { SharedAllModule } from '../shared-all/shared-all.module';

/*
 * Components
 */
import { Teacher } from './components/main/teacher.component';
import { CreateAssignments } from './components/create-assignments/create-assignments.component';
import { AssignmentPath } from './components/assignment-path/assignment-path.component';
import { LtiLinkPath } from './components/lti-link-path/lti-link-path.component';
import { ActivityRenderer } from './components/activity-renderer/activity-renderer.component';
import { Preview } from 'modules/learner/components/preview/preview.component';
import { CreateAccessRules } from './components/create-access-rules/create-access-rules.component';
import { UpdateBanner } from './components/update-banner/update-banner.component';
import { GenericErrorModal } from './components/generic-error-modal/generic-error-modal.component';
import { AssignmentDetail } from './components/assignment-detail/assignment-detail.component';

/*
 * Services
 */
import { CustomTranslationLoader } from './../app/services/custom-translation-loader';
import { AssignmentViewService } from './services/assignment-view.service';
import { AssignmentViewResolverService } from './services/assignment-view-resolver.service';
import { LtiHelperService } from './services/lti-helper.service';
import { CreateAccessResolverService } from './services/create-access-resolver.service';
import { ContentAccessService } from './services/content-access.service';
import { GradeActivitySelectionResolverService } from './services/grade-activity-selection-resolver.service';
import { GradeActivitySelectionService } from './services/grade-activity-selection.service';
import { LTIAssignmentsSharedService } from './services/lti-assignments-shared.service';
import { A11yModule } from '@angular/cdk/a11y';

export const MY_NATIVE_FORMATS = {
  fullPickerInput: {year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', hourCycle: 'h23'},
  datePickerInput: {year: 'numeric', month: 'short', day: 'numeric', weekday : 'short'},
  timePickerInput: {hour: 'numeric', minute: 'numeric'},
  monthYearLabel: {year: 'numeric', month: 'short'},
  dateA11yLabel: {year: 'numeric', month: 'short', day: 'numeric'},
  monthYearA11yLabel: {year: 'numeric', month: 'short'},
};
@NgModule({
  declarations: [
    Teacher,
    CreateAssignments,
    AssignmentPath,
    LtiLinkPath,
    ActivityRenderer,
    Preview,
    CreateAccessRules,
    UpdateBanner,
    GenericErrorModal,
    AssignmentDetail
  ],
  imports: [
    CommonModule,
    ROUTES,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslationLoader
      }
    }),
    SharedPostLoginModule,
    SharedAllModule,
    A11yModule
  ],
  providers:[
    { provide: OWL_DATE_TIME_FORMATS, useValue: MY_NATIVE_FORMATS },
    AssignmentViewService,
    AssignmentViewResolverService,
    CreateAccessResolverService,
    ContentAccessService,
    DatePipe,
    LtiHelperService,
    GradeActivitySelectionResolverService,
    GradeActivitySelectionService,
    LTIAssignmentsSharedService
  ]
})
export class TeacherModule {

}
